/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-imports */
import React, { useState, useEffect, useRef } from "react";
/*eslint-disable-next-line*/
import { shallowEqual, useSelector } from "react-redux";
import { Chip, TextField, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Skeleton } from "@material-ui/lab";
import * as PropTypes from "prop-types";
import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  DataTypeProvider,
  RowDetailState,
} from "@devexpress/dx-react-grid";

import { Eye, EyeSlashFill, TagFill, TagsFill, BoxSeamFill, Calendar } from "react-bootstrap-icons";

import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableFilterRow,
  TableRowDetail,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import SVG from "react-inlinesvg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faBoxOpen, faSquareCheck, faPrint } from "@fortawesome/free-solid-svg-icons";
/*eslint-disable-next-line*/
import { Form, Card, Tooltip, OverlayTrigger, Button, Modal } from "react-bootstrap";
import moment from "moment-timezone";

import { roles, roleOptionsForSelect, icons, statusRichiesta } from "../../config/config";
import * as apiRichieste from "../../api/richiesteMateriale";
import * as apiMateriali from "../../api/materiali";
import ArticoloEventoPicker from "./components/ArticoloEventoPicker";

function groupRichieste(list) {
  const map = new Map();
  list.forEach((item) => {
    const collection = map.get(item.idRichiesta);
    const {
      idRichiesta,
      idAgente,
      status,
      lastUpdate,
      agente,
      address,
      extra,
      quantity,
      idMateriale,
      sku,
      materiale,
      division,
      image,
      price,
      lot,
    } = item;
    if (!collection) {
      map.set(idRichiesta, {
        idRichiesta,
        idAgente,
        status: parseInt(status),
        lastUpdate,
        agente,
        address,
        extra: !!parseInt(extra),
        cart: [
          {
            idMateriale,
            sku: sku,
            name: materiale,
            quantity: parseInt(quantity),
            price: parseFloat(price),
            division,
            image,
            lot: parseInt(lot) || 1,
          },
        ],
      });
    } else {
      collection.cart.push({
        idMateriale,
        sku: sku,
        name: materiale,
        quantity: parseInt(quantity),
        price: parseFloat(price),
        division,
        image,
        lot: parseInt(lot) || 1,
      });
    }
  });
  for (let [idRichiesta, richiesta] of map) {
    map.set(idRichiesta, {
      ...richiesta,
      quantity: richiesta.cart.reduce((q, item) => q + item.quantity, 0),
    });
  }
  return map;
}

// Useful sub-components
const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table table-hover table-head-custom table-vertical-center overflow-hidden" />
);

const getTableRow = (clickCallback) => {
  return ({ row, ...restProps }) => (
    <Table.Row
      {...restProps}
      // eslint-disable-next-line no-alert
      onClick={() => clickCallback(restProps.tableRow.rowId)}
      style={{
        cursor: "pointer",
      }}
    />
  );
};

const FilterCell = (props) => {
  return <TableFilterRow.Cell {...props} />;
};
FilterCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

const DateFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => moment(value).format("DD MMMM YYYY, HH:mm")} {...props} />
);

const makeActionBtn = ({ name, disabled, tooltip, callback, variant, icon, value }) => {
  const btn = (
    <Button
      variant={variant}
      className={`mx-3 my-2`}
      onClick={!disabled ? () => callback(value) : null}
      disabled={disabled}
      title={name}
    >
      {typeof icon == "string" ? (
        <span className={`svg-icon svg-icon-md svg-icon-white`}>
          {" "}
          <SVG src={toAbsoluteUrl(icon)} />
        </span>
      ) : (
        <FontAwesomeIcon icon={icon} className={`svg-icon-white`} style={{ marginRight: "0.5rem" }} />
      )}
      <span className="text-white">{name}</span>
      {/* {name} */}
    </Button>
  );
  if (!tooltip) return btn;
  return <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>{btn}</OverlayTrigger>;
};

const StatoColumn = ({ value }) => {
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.inAttesa)
    return (
      // in attesa
      <div className="pl-3">
        <Chip
          variant="outlined"
          label="In attesa"
          icon={<FontAwesomeIcon icon={faBoxOpen} className="svg-icon-info svg-icon-md" />}
          style={{ borderColor: "var(--info)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  // if (value == statusRichiesta.approvato)
  //   return (
  //     // approvato
  //     <div className="pl-3">
  //       <Chip
  //         color="success"
  //         variant="outlined"
  //         label="Approvato"
  //         icon={icons.ok}
  //       />
  //     </div>
  //   );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.inevaso)
    return (
      // pronto
      <div className="pl-3">
        <Chip
          variant="outlined"
          label="Inevaso"
          icon={<FontAwesomeIcon icon={faBox} className="svg-icon-warning svg-icon-md" />}
          style={{ borderColor: "var(--warning)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.evaso)
    return (
      // consegnato
      <div className="pl-3">
        <Chip
          variant="outlined"
          label="Evaso"
          icon={<FontAwesomeIcon icon={faSquareCheck} className="svg-icon-primary svg-icon-md" />}
          style={{ borderColor: "var(--primary)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.rifiutato)
    return (
      // cancellato
      <div className="pl-3">
        <Chip
          variant="outlined"
          label="Rifiutato"
          icon={
            <span className="svg-icon svg-icon-md svg-icon-danger">
              {" "}
              <SVG src={toAbsoluteUrl(icons.close)} />
            </span>
          }
          style={{ borderColor: "var(--danger)" }}
        />
      </div>
    );
  return <div className="pl-3"></div>;
};

export const StatoFormattedColumn = (props) => <DataTypeProvider formatterComponent={StatoColumn} {...props} />;

const useStyles = makeStyles({
  noExtra: {
    width: 25,
    height: 25,
    backgroundColor: "var(--primary)",
  },
  extra: {
    width: 25,
    height: 25,
    backgroundColor: "var(--danger)",
  },
  removedItem: {
    textDecoration: "line-through",
    opacity: 0.5,
  },
});

const ExtraColumn = ({ value }) => {
  const classes = useStyles();
  /*eslint-disable-next-line*/
  // if (value == false)
  // return (
  //     <Avatar className={classes.noExtra}>
  //             <span className="svg-icon svg-icon-md svg-icon-white">
  //                 {" "}
  //                 <SVG src={toAbsoluteUrl(icons.close)} />
  //             </span>
  //         </Avatar>
  //     );
  /*eslint-disable-next-line*/
  if (value == true)
    return (
      <Avatar className={classes.extra}>
        <span className="svg-icon svg-icon-md svg-icon-white">
          {" "}
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {/* <i className="ki ki-plus icon-white"></i> */}
      </Avatar>
    );
  return <></>;
};

export const ExtraFormattedColumn = (props) => <DataTypeProvider formatterComponent={ExtraColumn} {...props} />;

const QuantityInput = React.memo(({ rowId, item, updateLocalQuantityCallback, value }) => {
  const handleChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    const colli = Math.max(0, Math.ceil(newValue / item.lot));
    updateLocalQuantityCallback(rowId, item.idMateriale, colli);
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const displayValue = value; // * item.lot;

  return (
    <input
      type="number"
      value={displayValue}
      onChange={handleChange}
      min={0}
      style={{ width: "60px", textAlign: "center" }}
      onFocus={handleFocus}
      onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
    />
  );
});

export const AddMaterialeForm = ({ rowId, cart, materialiCatalog, addToCartCallback }) => {
  const [newMateriale, setNewMateriale] = useState(null);
  const [newMaterialeQty, setNewMaterialeQty] = useState(1);
  const [isAdding, setIsAdding] = useState(false);

  return (
    <div className="card card-custom bg-light border-dashed m-3">
      <div className="card-header border-0 py-3">
        <h6 className="font-weight-bold text-dark m-0">Aggiungi Materiale</h6>
      </div>
      <div className="card-body">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1 mr-3">
            <ArticoloEventoPicker
              options={materialiCatalog
                .filter((materiale) => !cart.some((item) => item.sku === materiale.sku))
                .map((materiale) => ({
                  sku: materiale.sku,
                  nomeArticolo: materiale.name,
                  tipoArticolo: "materiale_pubblicitario",
                  image: materiale.image,
                  qta: materiale.qta,
                  division: materiale.division,
                  _id: materiale.id,
                  _lot: materiale.quantity,
                }))}
              value={newMateriale}
              onChange={setNewMateriale}
            />
          </div>
          <div style={{ width: 80 }} className="mr-3">
            <Form.Control
              type="number"
              min="1"
              value={newMaterialeQty}
              onChange={(e) => setNewMaterialeQty(Math.max(1, parseInt(e.target.value) || 1))}
              placeholder="Colli"
            />
          </div>
          <Button
            variant="primary"
            disabled={!newMateriale || isAdding}
            onClick={async () => {
              if (!newMateriale) return;
              setIsAdding(true);
              try {
                await addToCartCallback(rowId, newMateriale._id, newMaterialeQty);
                setNewMateriale(null);
                setNewMaterialeQty(1);
              } catch (e) {
                console.error("Errore aggiunta materiale:", e);
              } finally {
                setIsAdding(false);
              }
            }}
          >
            {isAdding ? "..." : "Aggiungi"}
          </Button>
        </div>
        <small className="text-muted">La quantità è espressa in colli.</small>
      </div>
    </div>
  );
};

const RichiestaRowDetail = ({
  getPrintRef,
  isRowLoading,
  isItemLoading,
  isEditing,
  editedValue,
  openHistory,
  setOpenHistory,
  openPrice,
  setOpenPrice,
  canApprove,
  updateStatusCallback,
  extraCallback,
  addToCartCallback,
  updateLocalQuantityCallback,
  pendingChanges,
  handleSaveAllChanges,
  isSavingAll,
  resetPendingChanges,
}) => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const printRefs = useRef({});
  const classes = useStyles();
  const [materialiCatalog, setMaterialiCatalog] = useState([]);

  useEffect(() => {
    if (!user || !user.authToken) return;
    apiMateriali.getAll(user.authToken)
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        setMaterialiCatalog(arr.filter((materiale) => materiale.available));
      })
      .catch(() => setMaterialiCatalog([]));
    /*eslint-disable-next-line*/
  }, []);

  // Nuovi stati per il modal di conferma
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
  const [itemToRemoveDetails, setItemToRemoveDetails] = useState(null);

  // Funzione per aprire il modal di conferma
  const handleRemoveClick = (rowId, itemId) => {
    setItemToRemoveDetails({ rowId, itemId });
    setShowRemoveConfirmation(true);
  };

  // Funzione per confermare la rimozione (imposta la quantità a 0)
  const handleConfirmRemove = () => {
    if (itemToRemoveDetails) {
      updateLocalQuantityCallback(itemToRemoveDetails.rowId, itemToRemoveDetails.itemId, 0);
      setShowRemoveConfirmation(false);
      setItemToRemoveDetails(null);
    }
  };

  // Funzione per chiudere il modal senza rimuovere
  const handleCloseRemoveModal = () => {
    setShowRemoveConfirmation(false);
    setItemToRemoveDetails(null);
  };

  return (
    <TableRowDetail
      contentComponent={({ row }) => {
        const isDisabled = {
          edit:
            (!canApprove && row.status != statusRichiesta.inAttesa) ||
            (canApprove && row.status == statusRichiesta.evaso),
          cancel:
            (!canApprove && row.status != statusRichiesta.inAttesa) ||
            (canApprove && (row.status == statusRichiesta.evaso || row.status == statusRichiesta.rifiutato)),
          setInevaso: row.status == statusRichiesta.inevaso || row.status == statusRichiesta.evaso,
          setEvaso: row.status == statusRichiesta.evaso,
        };
        const shownQuantity = {};
        for (var item of row.cart) {
          shownQuantity[item.idMateriale] = isEditing(row.idRichiesta, item.idMateriale)
            ? editedValue(row.idRichiesta, item.idMateriale)
            : item.quantity;
        }

        // Funzione per attivare/disattivare la visibilità dello storico
        const toggleHistory = (idCampione) => {
          setOpenHistory((prevState) => ({
            ...prevState,
            [idCampione]: !prevState[idCampione],
          }));
        };

        const togglePrice = (idCampione) => {
          setOpenPrice((prevState) => ({
            ...prevState,
            [idCampione]: !prevState[idCampione],
          }));
        };

        // Funzione per verificare se lo storico è aperto
        const isHistoryClosed = (idCampione) => openHistory[idCampione] || false;

        // Funzione per verificare se i prezzi sono mostrati
        const isPriceOpen = (idCampione) => openPrice[idCampione] || false;

        const handlePrint = () => {
          const content = getPrintRef(row.idRichiesta)?.current;
          if (!content) return;

          // Crea un iframe invisibile
          const iframe = document.createElement("iframe");
          iframe.style.position = "absolute";
          iframe.style.top = "-9999px";
          iframe.style.left = "-9999px";
          iframe.style.width = "1px";
          iframe.style.height = "1px";
          document.body.appendChild(iframe);

          const doc = iframe.contentWindow.document;
          // Scrivi il contenuto nell'iframe
          doc.open();
          doc.write(`
                        <html>
                        <head>
                            <title>Richiesta #${row.idRichiesta}</title>


                            <!-- Bootstrap -->
                            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" />

                            <!-- Font Awesome -->
                            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css " />

                            <style>
                            body {
                                font-family: Arial, sans-serif;
                                padding: 12px;
                                margin: 0;
                            }
                            table, tr, td, th {
                                border: 1px solid #000;
                                border-collapse: collapse;
                                padding: 8px;
                                text-align: left;
                            }

                            .no-print {
                                display: none !important;
                            }

                            .symbol {
                                display: inline-block;
                                position: relative;
                                vertical-align: middle;
                                overflow: hidden;
                            }

                            .symbol.symbol-50, .symbol.symbol-70 {
                                width: 50px;
                                height: 50px;
                            }

                            .symbol img {
                                margin-right:22px;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 0.42rem;
                            }

                            .font-size-lg {
                                font-size:18px;
                            }

                            .print-chip-container {
                                display: flex !important;
                                flex-wrap: nowrap !important;
                                overflow: hidden !important;
                                width: 100% !important;
                            }

                            .print-chip-container .MuiChip-root {
                                flex-shrink: 0 !important;
                                white-space: nowrap !important;
                                min-width: max-content !important;
                            }

                            .MuiChip-label {
                        overflow: hidden;
                        white-space: nowrap;
                        padding-left: 12px;
                        padding-right: 12px;
                        text-overflow: ellipsis;
                        }
                            </style>
                        </head>
                        <body>
                            ${content.innerHTML}
                        </body>
                        </html>
                        `);
          doc.close();

          // Avvia la stampa
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          }, 500);
        };

        return (
          <>
            <div
              key={`print-${row.idRichiesta}`}
              ref={getPrintRef(row.idRichiesta)}
              className="card printable-area"
              data-row-id={row.idRichiesta}
            >
              <div className="card">
                {row.cart.map((item) => (
                  <React.Fragment key={`cart-${item.idMateriale}-${row.idRichiesta}`}>
                    <div
                      className={`d-flex align-items-center justify-content-xl-between p-8 ${
                        shownQuantity[item.idMateriale] === 0 ? classes.removedItem : ""
                      }`}
                    >
                      <div className="d-flex flex-column mr-2 order-2 order-xl-1 ml-2 flex-grow-1">
                        {/*eslint-disable-next-line*/}
                        <span className="font-weight-bold text-dark-75 font-size-lg text-hover-primary">
                          {item.sku} - {item.name}
                          {isDisabled.edit ? null : (
                            <OverlayTrigger overlay={<Tooltip>Rimuovi Articolo</Tooltip>}>
                              <Button
                                variant="light-danger"
                                className="btn-xs btn-icon ml-2"
                                disabled={isItemLoading(row.idRichiesta, item.idMateriale)}
                                onClick={() => handleRemoveClick(row.idRichiesta, item.idMateriale)}
                              >
                                <i className="ki ki-close icon-xs"></i>
                              </Button>
                            </OverlayTrigger>
                          )}
                        </span>
                        <div className="d-flex align-items-center mt-2 flex-wrap">
                          <span className="ml-2 mr-2 text-dark-75 font-size-1 text-muted text-nowrap">
                            {shownQuantity[item.idMateriale] * item.lot} pezzi
                          </span>
                          <span className="text-muted mr-2">=</span>
                          <span className="font-weight-bold mr-1 text-dark-75 font-size-1 text-nowrap">
                            {shownQuantity[item.idMateriale] !== 1
                              ? `${shownQuantity[item.idMateriale] } colli`
                              : "1 collo"}
                          </span>
                          <span className="text-dark-75 mr-1"> &#215; </span>
                          <span className="mr-2 text-dark-75 font-size-1 text-muted text-nowrap">
                            <TagFill className="d-inline-block align-middle mr-1" /> {item.lot} pz.
                          </span>

                          {isPriceOpen(item.idMateriale) && (
                            <span className="mr-2 text-dark-75 font-size-3">
                              {typeof item.price !== "undefined" ? `${item.price}€` : "-€"}
                            </span>
                          )}

                          {/* <span className="text-muted mr-1"> &#215; </span>
                          <span className="font-weight-bold mr-1 text-dark-75 font-size-3">
                            {isEditing(row.idRichiesta, item.idMateriale) ? (
                              <>{editedValue(row.idRichiesta, item.idMateriale)}</>
                            ) : (
                              <> {shownQuantity[item.idMateriale]} </>
                            )}
                          </span> */}
                          <span className="text-muted mr-2">=</span>
                          <span className="mr-2 text-dark-75 font-size-3">
                            {typeof item.price !== "undefined"
                              ? `${((shownQuantity[item.idMateriale]) * item.price).toFixed(2)}€`
                              : "-€"}
                          </span>
                        </div>

                        <div className="d-flex align-items-center mt-2">
                          {isDisabled.edit ? null : (
                            <>
                              <div className="d-flex align-items-center">
                                {" "}
                                {/* New div to group buttons and input */}
                                {/* <label className="text-muted font-size-sm mb-2">Modifica Quantità</label>{" "} */}
                                {/* New Label */}
                                <OverlayTrigger overlay={<Tooltip>Rimuovi Collo</Tooltip>}>
                                  <Button
                                    variant="light-warning"
                                    className="btn-xs btn-icon mr-2"
                                    disabled={isItemLoading(row.idRichiesta, item.idMateriale)}
                                    onClick={() =>
                                      updateLocalQuantityCallback(
                                        row.idRichiesta,
                                        item.idMateriale,
                                        Math.max(0, shownQuantity[item.idMateriale] - 1),
                                      )
                                    }
                                  >
                                    <i className="ki ki-minus icon-xs"></i>
                                  </Button>
                                </OverlayTrigger>
                                <QuantityInput
                                  rowId={row.idRichiesta}
                                  item={item}
                                  updateLocalQuantityCallback={updateLocalQuantityCallback}
                                  value={shownQuantity[item.idMateriale]}
                                />
                                <OverlayTrigger overlay={<Tooltip>Aggiungi Collo</Tooltip>}>
                                  <Button
                                    variant="light-success"
                                    className="btn-xs btn-icon ml-2"
                                    disabled={isItemLoading(row.idRichiesta, item.idMateriale)}
                                    onClick={() =>
                                      updateLocalQuantityCallback(
                                        row.idRichiesta,
                                        item.idMateriale,
                                        shownQuantity[item.idMateriale] + 1,
                                      )
                                    }
                                  >
                                    <i className="ki ki-plus icon-xs"></i>
                                  </Button>
                                </OverlayTrigger>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {typeof item.image !== "undefined" && item.image !== "" && item.image !== "0" ? ( // TODO: REMOVE THE 0 ?
                        <div className="symbol symbol-70 order-xl-2">
                          <img
                            src={toAbsoluteUrl(item.image)}
                            // src={item.image.startsWith("/") ? process.env.REACT_APP_MEDIA_URL + item.image : item.image}
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className="separator separator-solid"></div>
                  </React.Fragment>
                ))}
                {isDisabled.edit ? null : (
                  <AddMaterialeForm
                    rowId={row.idRichiesta}
                    cart={row.cart}
                    materialiCatalog={materialiCatalog}
                    addToCartCallback={addToCartCallback}
                  />
                )}
                <div className="p-8">
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Numero di colli</span>
                    <span className="font-weight-bolder text-primary text-right">
                      {row.cart.reduce((q, item) => q + shownQuantity[item.idMateriale], 0)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Pezzi totali</span>
                    <span className="font-weight-bolder text-dark-50 text-right">
                      {row.cart.reduce((sum, item) => sum + shownQuantity[item.idMateriale] * item.lot, 0)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-7">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Valore totale</span>
                    <span className="font-weight-bolder text-dark-50 text-right">
                      {row.cart
                        .reduce(
                          (sum, item) =>
                            typeof item.price !== "undefined"
                              ? sum + item.price * shownQuantity[item.idMateriale]
                              : sum,
                          0,
                        )
                        .toFixed(2)}
                      €
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Agente</span>
                    <span className="font-weight-bolder text-dark-50 text-right">{row.agente}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Indirizzo</span>
                    <span className="font-weight-bolder text-dark-50 text-right">{row.address}</span>
                  </div>
                </div>
                <div className="separator separator-solid"></div>
              </div>
            </div>
            <div>
              <div className="float-xl-right no-print">
                {/* Bottone "Salva tutte le modifiche" */}
                {Object.keys(pendingChanges).length > 0 && (
                  <Button
                    variant="primary"
                    className="mx-3 my-2"
                    onClick={() => handleSaveAllChanges(row.idRichiesta)}
                    disabled={isSavingAll}
                  >
                    {isSavingAll ? "Salvataggio..." : "Salva modifiche"}
                  </Button>
                )}
                {Object.keys(pendingChanges).length > 0 && (
                  <Button
                    variant="light-danger"
                    className="mx-3 my-2"
                    onClick={() => resetPendingChanges(row.idRichiesta)}
                    disabled={isSavingAll}
                  >
                    Annulla
                  </Button>
                )}

                {makeActionBtn({
                  name: "Stampa",
                  callback: () => handlePrint(),
                  disabled: false,
                  variant: "success",
                  icon: faPrint,
                  value: row.idRichiesta,
                })}

                {makeActionBtn({
                  name: row.extra ? "Regolare" : "Extra",
                  callback: row.extra ? (id) => extraCallback(id, 0) : (id) => extraCallback(id, 1),
                  disabled: isRowLoading(row.idRichiesta) || isDisabled.edit,
                  variant: "info",
                  icon: icons.edit,
                  value: row.idRichiesta,
                })}
                {makeActionBtn({
                  name: canApprove ? "Rifiuta" : "Annulla",
                  callback: (id) => updateStatusCallback(id, statusRichiesta.rifiutato),
                  disabled: isRowLoading(row.idRichiesta) || isDisabled.cancel,
                  variant: "danger",
                  icon: icons.close,
                  value: row.idRichiesta,
                })}
                {canApprove
                  ? makeActionBtn({
                      name: "Pronto",
                      tooltip: "Pronto per ritiro/spedizione",
                      callback: (id) => updateStatusCallback(id, statusRichiesta.inevaso),
                      disabled: isRowLoading(row.idRichiesta) || isDisabled.setInevaso,
                      variant: "warning",
                      icon: faBox,
                      value: row.idRichiesta,
                    })
                  : null}
                {canApprove
                  ? makeActionBtn({
                      name: "Evaso",
                      callback: (id) => updateStatusCallback(id, statusRichiesta.evaso),
                      disabled: isRowLoading(row.idRichiesta) || isDisabled.setEvaso,
                      variant: "primary",
                      icon: faSquareCheck,
                      value: row.idRichiesta,
                    })
                  : null}
              </div>
            </div>

            {/* Modal di conferma rimozione */}
            <Modal show={showRemoveConfirmation} onHide={handleCloseRemoveModal}>
              <Modal.Header closeButton>
                <Modal.Title>Conferma Rimozione Articolo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Sei sicuro di voler rimuovere questo articolo dalla richiesta? L'articolo verrà rimosso solo al
                salvataggio delle modifiche.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseRemoveModal}>
                  Annulla
                </Button>
                <Button variant="danger" onClick={handleConfirmRemove}>
                  Conferma Rimozione
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      }}
    />
  );
};

// Columns definition
const materialiColumns = [
  { name: "agente", title: "Agente" },
  { name: "quantity", title: "Quantità" },
  { name: "extra", title: "Extra" },
  { name: "status", title: "Stato" },
  { name: "lastUpdate", title: "Dal" },
  { name: "address", title: "Indirizzo" },
];
const materialiColumnExtensions = [
  { columnName: "agente", wordWrapEnabled: true },
  { columnName: "quantity", width: "auto" },
  { columnName: "extra", width: "auto" },
  { columnName: "status", width: "auto" },
  { columnName: "lastUpdate", wordWrapEnabled: true },
  { columnName: "address", wordWrapEnabled: true },
];

// Messages
const tableMessages = {
  noData: "Nessuna richiesta effettuata",
};
const filterRowMessages = {
  filterPlaceholder: "Filtra...",
};
const pagingPanelMessages = {
  showAll: "Tutte",
  rowsPerPage: "Righe per pagina",
  info: "Da {from} a {to} ({count} richieste)",
};

// Paging and sorting
const pageSizes = [10, 20, 30, 0];
const initialPageSize = 10;
const initialSorting = [{ columnName: "lastUpdate", direction: "desc" }];

export const RichiesteMateriale = () => {
  const printRefs = useRef({});
  // table data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRows, setLoadingRows] = useState({});
  const [loadingItems, setLoadingItems] = useState({});
  const [pendingChanges, setPendingChanges] = useState({});
  const [isSavingAll, setIsSavingAll] = useState(false);
  const [_internalUpdateCount, _setInternalUpdateCount] = useState(0);

  const [openHistory, setOpenHistory] = useState({});
  const [openPrice, setOpenPrice] = useState({});

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  // nascondi colonna "agente" se non admin/magazziniere
  const columns =
    role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.magazziniere
      ? materialiColumns
      : materialiColumns.slice(1);

  const updateFromServer = () => {
    setLoading(true);

    apiRichieste
      .getAll(user.authToken)
      .then((data) => setRows(groupRichieste(data)))
      .then(() => setLoading(false));
  };
  useEffect(() => {
    updateFromServer();
    /*eslint-disable-next-line*/
  }, [_internalUpdateCount]);

  const doUpdate = () => {
    _setInternalUpdateCount(_internalUpdateCount + 1);
  };

  const addLoadingRow = (id) => {
    const clone = { ...loadingRows };
    clone[id] = true;
    setLoadingRows(clone);
  };
  const removeLoadingRow = (id) => {
    const clone = { ...loadingRows };
    delete clone[id];
    setLoadingRows(clone);
  };

  const addLoadingItem = (id, idMateriale) => {
    const clone = { ...loadingItems };
    if (!(id in clone)) {
      //clone[id] = {...loadingItems[id]};
      clone[id] = {};
    }
    clone[id][idMateriale] = true;
    setLoadingItems(clone);
  };
  const removeLoadingItem = (id, idMateriale) => {
    const clone = { ...loadingItems };
    if (id in clone) {
      if (idMateriale in clone[id]) {
        delete clone[id][idMateriale];
      }
      if (!clone[id]) {
        delete clone[id];
      }
    }
    setLoadingItems(clone);
  };

  const updateLocalQuantity = (idRichiesta, idMateriale, quantity) => {
    setPendingChanges((prev) => ({
      ...prev,
      [idRichiesta]: {
        ...(prev[idRichiesta] || {}),
        [idMateriale]: quantity,
      },
    }));
  };

  const isEditing = (idRichiesta, idMateriale) => {
    return idRichiesta in pendingChanges && idMateriale in pendingChanges[idRichiesta];
  };

  const getEditedValue = (idRichiesta, idMateriale) => {
    if (isEditing(idRichiesta, idMateriale)) {
      return pendingChanges[idRichiesta][idMateriale];
    }
    const richiesta = rows.get(idRichiesta);
    if (richiesta) {
      const item = richiesta.cart.find((c) => c.idMateriale === idMateriale);
      return item ? item.quantity : undefined;
    }
    return undefined;
  };

  const resetPendingChanges = (idRichiesta) => {
    setPendingChanges((prev) => {
      const newPending = { ...prev };
      delete newPending[idRichiesta];
      return newPending;
    });
  };

  const handleSaveAllChanges = async (idRichiesta) => {
    setIsSavingAll(true);
    addLoadingRow(idRichiesta);

    const changesToSave = pendingChanges[idRichiesta];
    if (!changesToSave) {
      removeLoadingRow(idRichiesta);
      setIsSavingAll(false);
      return;
    }

    const promises = Object.keys(changesToSave).map(async (idMateriale) => {
      const newQuantity = changesToSave[idMateriale];
      addLoadingItem(idRichiesta, idMateriale);
      try {
        if (newQuantity === 0) {
          await apiRichieste.removeFromCart(user.authToken, idRichiesta, idMateriale);
        } else {
          await apiRichieste.updateCartQuantity(user.authToken, idRichiesta, idMateriale, newQuantity);
        }
      } catch (error) {
        console.error("Errore durante il salvataggio:", error);
      } finally {
        removeLoadingItem(idRichiesta, idMateriale);
      }
    });

    await Promise.all(promises);
    removeLoadingRow(idRichiesta);
    resetPendingChanges(idRichiesta);
    doUpdate();
    setIsSavingAll(false);
  };

  // paging and sorting
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [sorting, setSorting] = useState(initialSorting);
  const [expandedRows, setExpandedRows] = useState([]);

  /*eslint-disable-next-line*/
  return (
    <>
      <Card className="card-custom gutter-b">
        <Card.Header className="border-0 py-5 row">
          <Card.Title className="float-left col-auto">
            <div>
              <h3 className="font-weight-bolder text-dark">Richieste di Materiale Pubblicitario</h3>
              <h6 className="font-weight-light text-dark mobile-only">
                Scorri a destra la tabella per altre informazioni
              </h6>
            </div>
          </Card.Title>
        </Card.Header>
        <Card.Body className="pt-0">
          <div className="mr-3 ml-3 alert alert-secondary text-right" role="alert">
            <strong>Legenda stati</strong> 0: In attesa, 1: Approvato, 2: Rifiutato
          </div>
          {!loading ? (
            <Grid rows={[...rows.values()]} columns={columns}>
              <DateFormattedColumn for={["lastUpdate"]} />
              <StatoFormattedColumn for={["status"]} />
              <ExtraFormattedColumn for={["extra"]} />
              <RowDetailState expandedRowIds={expandedRows} onExpandedRowIdsChange={setExpandedRows} />
              <FilteringState />
              <IntegratedFiltering />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={setPageSize}
              />
              <IntegratedPaging />
              <SortingState sorting={sorting} onSortingChange={setSorting} />
              <IntegratedSorting />
              <Table
                messages={tableMessages}
                tableComponent={TableComponent}
                columnExtensions={materialiColumnExtensions}
                rowComponent={getTableRow((id) =>
                  setExpandedRows(
                    expandedRows.includes(id) ? [...expandedRows].filter((v) => v != id) : [...expandedRows, id],
                  ),
                )}
              />
              <TableHeaderRow showSortingControls />
              <TableFilterRow messages={filterRowMessages} cellComponent={FilterCell} />
              <RichiestaRowDetail
                /*eslint-disable-next-line*/
                getPrintRef={(id) => {
                  if (!printRefs.current[id]) printRefs.current[id] = React.createRef();
                  return printRefs.current[id];
                }}
                canApprove={role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.magazziniere}
                isRowLoading={(id) => id in loadingRows}
                isItemLoading={(id, idMateriale) => id in loadingItems && idMateriale in loadingItems[id]}
                isEditing={isEditing}
                editedValue={getEditedValue}
                openHistory={openHistory}
                setOpenHistory={setOpenHistory}
                setOpenPrice={setOpenPrice}
                openPrice={openPrice}
                updateStatusCallback={(id, status) => {
                  addLoadingRow(id);
                  apiRichieste.update(user.authToken, id, status).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  });
                }}
                extraCallback={(id, value) => {
                  addLoadingRow(id);
                  apiRichieste.extra(user.authToken, id, value).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  });
                }}
                addToCartCallback={(id, idMateriale, quantity) => {
                  addLoadingRow(id);
                  return apiRichieste.addToCart(user.authToken, id, idMateriale, quantity).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  }).catch((e) => {
                    removeLoadingRow(id);
                    throw e;
                  });
                }}
                updateLocalQuantityCallback={updateLocalQuantity}
                pendingChanges={pendingChanges}
                handleSaveAllChanges={handleSaveAllChanges}
                isSavingAll={isSavingAll}
                resetPendingChanges={resetPendingChanges}
              />
              <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />
            </Grid>
          ) : (
            <div>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="rect" height={518} />
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
